export default __webpack_public_path__ + "static/media/CalendarLarge.76ab6cc8.svg";